export default "__VITE_ASSET__CMie3qU8__"